export const getVotes = async (site_id, request_uri) => {
  const formData = new FormData();
  formData.append('site_id', site_id);
  formData.append('request_uri', request_uri);

  return fetch('https://visitor.natu.care/get-votes', {
    method: 'POST',
    body: formData
  })
    .then(response => response.text())
    .then(result => {
      if (result === 'NO OR INCORRECT DATA PASSED (site_id & request_uri are required)') {
        return {
          request_uri: request_uri,
          score: 0,
          votes: 0
        };
      }

      return JSON.parse(result);
    })
    .catch(error => {
      console.error(error);
    });
};
